import { useState, useContext, useCallback, useEffect, useRef } from "react";
import { CommandBarButton, Stack, TextField, ThemeSettingName, fontFace } from "@fluentui/react";
import { AppStateContext } from "../../state/AppProvider";
import MediaQuery from "react-responsive";
import { Rating } from 'react-simple-star-rating'
/*import { ReCAPTCHA } from 'react-google-recaptcha';*/
import styles from "./Feedback.module.css";
import TextareaAutosize from "react-textarea-autosize";

interface Props {
    onSend: (rating: number, feedback: string, id?: string, messageid?:string, feedbackmsg?: string) => void;
    disabled: boolean;
    darkmode: boolean;
    placeholder?: string;
    clearOnSend?: boolean;
    conversationId?: string;
    thankYouMessagePayload: string | null; 
    showThankYouMessage: boolean;
    setShowThankYouMessage: (value: boolean) => void;
    setPopUpBlocker: (popUpBlocker: boolean) => void;
}

export const Feedback = ({ 
                        onSend, disabled, darkmode, placeholder, clearOnSend, conversationId, thankYouMessagePayload,
                        showThankYouMessage, setShowThankYouMessage, setPopUpBlocker
                        }: Props) => {
    const [feedback, setFeedback] = useState<string>("");
    const [textAreaCount, setTextAreaCount] = useState(0);
    const [rating, setRating] = useState(0);
    const appStateContext = useContext(AppStateContext);
    var branding = appStateContext?.state.frontendSettings?.branding;
    const [announceRating, setAnnounceRating] = useState<string>("");

    const handleRating = (rate: number) => {
        //console.log("rate:" + rate);
        setRating(rate)
    
        // other logic
    }

    useEffect(() => {
        const closePopUp = (e: KeyboardEvent) => {
            if (e.key === "Escape" && appStateContext?.state.isFeedbackPanelOpen) {
                e.stopPropagation();
                closeFeedback();
            }
        };
        window.addEventListener("keydown", closePopUp, true);
        return () => {
            window.removeEventListener("keydown", closePopUp, true);
        };
    }, [appStateContext?.state.isFeedbackPanelOpen]);
   
    // Optional callback functions
    const onPointerEnter = () => console.log('Enter')
    const onPointerLeave = () => console.log('Leave')
    const onPointerMove = (value: number, index: number) => {
        console.log(value, index)
         
    };

    const closeFeedback   = () => {
        setPopUpBlocker(false);
        setFeedback("");
        setRating(0);
        setTextAreaCount(0);
        setAnnounceRating("");
        sessionStorage.msgID = "";
        sessionStorage.msgFB = "neutral"
        appStateContext?.dispatch({ type: 'MSGFB', payload: 'N' })
        appStateContext?.dispatch({ type: 'CLOSE_FEEDBACK_PANEL' })
        setTimeout(() => { setShowThankYouMessage(false); }, 3000);
    };
    
    const sendFeedback = () => {
    
        if (disabled || (!feedback.trim() && rating  == 0)) {
            return;
        }

        if(conversationId){
            let messageId = sessionStorage.msgID;
            let messageFb = sessionStorage.msgFB;
            //console.log("FB state" + appStateContext?.state.isMsgFB);
            if (appStateContext?.state.isMsgFB === "N"){
                messageId="";
                messageFb="neutral";
            }
            //console.log("FB msgID" + messageId);
            onSend(rating  , feedback, conversationId, messageId, messageFb);
            
            setFeedback("");
            setRating(0);
            setTextAreaCount(0);
            sessionStorage.msgID = "";
            sessionStorage.msgFB = "neutral"
            appStateContext?.dispatch({ type: 'MSGFB', payload:'N' })
            
        }else{
           return;
        }
        
        if (clearOnSend) {
            setFeedback("");
            setRating(0);
            setTextAreaCount(0);
        }
        
        //console.log('thankYouMessagePayload:', thankYouMessagePayload);
        //console.log('rating:', rating);
        setShowThankYouMessage(true);
        setTimeout(() => {
            closeFeedback();
            setPopUpBlocker(false);
        }, 9000);
    };

    const onEnterPress = (ev: React.KeyboardEvent<Element>) => {
        if (ev.key === "Enter" && !ev.shiftKey) {
            ev.preventDefault();
            sendFeedback();
        }
    };

    // const onFeedbackChange = (_ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
    //     var txt = ""
    //     if (newValue) {
    //         txt = newValue;
    //     }
    //     //console.log("rate:" +  rating);
    //     setTextAreaCount(txt.length);
    //     setFeedback(newValue || "");
    // };
    const onFeedbackChange = useCallback((_ev: React.ChangeEvent<HTMLTextAreaElement>) => {
        var txt = ""
        if (_ev.target.value ?? "") {
            txt = _ev.target.value ?? ""
        }
        setTextAreaCount(txt.length);
        setFeedback(txt);
       
        },
        [setFeedback, setTextAreaCount],
    );

    const sendFeedbackDisabled = disabled || (!feedback.trim() && rating  == 0);

    {/*Observe changes to hidden elements - indicates Google Translation occurred. 
      Update state variables to ensure UI stays consistent with the translated language*/}
    let titleSeperatorValue = "out of";
    const thankYouMessageValue1 = "Thank you for sharing your positive feedback! Your input is valuable and will assist us in enhancing our service for you and others in the future.";
    const thankYouMessageValue2 = "Thank you for sharing your feedback! Your input is valuable and will assist us in enhancing our service for you and others in the future.";
    const [titleSeparator, setTitleSeparator] = useState<string>(titleSeperatorValue);   
    const [thankYouMessage1, setThankYouMessage1] = useState<string>(thankYouMessageValue1);
    const [thankYouMessage2, setThankYouMessage2] = useState<string>(thankYouMessageValue2);

    const updateElementValue = (element: HTMLElement | null, setter: React.Dispatch<React.SetStateAction<string>>) => {
      if (element) {
          setter(element.innerText);
      }
    };
    
    useEffect(() => {
      const configs = [
          { id: "hidden_title_separator", setter: setTitleSeparator },
          { id: "hidden_thankyou_message1", setter: setThankYouMessage1 },
          { id: "hidden_thankyou_message2", setter: setThankYouMessage2 }
      ];
  
      const observers: MutationObserver[] = [];
  
      configs.forEach(({ id, setter }) => {
          const element = document.getElementById(id);
          if (element) {
              updateElementValue(element, setter);
              const observer = new MutationObserver(() => updateElementValue(element, setter));
              observer.observe(element, {
                  childList: true,
                  subtree: true,
                  characterData: true
              });
              observers.push(observer);
          }
      });
  
      return () => {
          observers.forEach(observer => observer.disconnect());
      };
  }, []);

    const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
      if (e.key === "ArrowRight" || e.key === "ArrowUp") {
          setRating((prev) => Math.min(prev + 0.5, 5)); // Increase rating
      } else if (e.key === "ArrowLeft" || e.key === "ArrowDown") {
          setRating((prev) => Math.max(prev - 0.5, 0)); // Decrease rating
      }
  };

    const announceRatingRef = useRef<HTMLDivElement>(null);

    const handleTouch = (e: React.TouchEvent<HTMLDivElement>) => {
      e.preventDefault();
      e.stopPropagation();
      
      setRating((prev) => {
        const newRating = prev >= 5 ? 0 : prev + 0.5;
        
        // Direct DOM update through the ref
        if (announceRatingRef.current) {
          announceRatingRef.current.textContent = `Rating: ${newRating} out of 5`;
        }
        
        return newRating;
      });
    };

    return (
        <Stack horizontal horizontalAlign="center">
            <div>
                {/* Hidden elements for Google Translate */}
                <div id="hidden_title_separator" style={{ display: 'none' }}>{titleSeperatorValue}</div>
                <div id="hidden_thankyou_message1" style={{ display: 'none' }}>{thankYouMessageValue1}</div>
                <div id="hidden_thankyou_message2" style={{ display: 'none' }}>{thankYouMessageValue2}</div>
                <div
                  tabIndex={showThankYouMessage ? 0 : -1}
                  aria-live={showThankYouMessage ? "polite" : "off"}
                  className={styles.feedbackGeneralTextWithTopMargin} 
                  style={{ marginTop: showThankYouMessage ? '40px' : '0px' }}
                >
                  {showThankYouMessage ? (
                      thankYouMessagePayload === 'positive' && rating > 3
                          ? thankYouMessage1
                          : thankYouMessage2
                  ) : ""}
                </div>
                {!showThankYouMessage && (
                <Stack className={styles.feedbackContainer}>
                    <span className={styles.feedbackGeneralText}>
                        <span tabIndex={0}>{branding?.feedback_info_text}</span>
                        <br />
                        <div className={styles.starText}>
                            <span tabIndex={0}>How would you rate your overall experience? </span><br />
                            <Stack role="slider" aria-valuemin={0} aria-valuemax={5} aria-valuenow={rating} aria-valuetext={`${rating} out of 5 stars`} aria-label="Rating" horizontal className={styles.feedback5starContainer} tabIndex={0} onKeyDown={handleKeyDown} onTouchStart={handleTouch}>
                                <Rating
                                    onClick={handleRating}
                                    fillColor={"var(--YW_Theme_Active_Button_Background_Color)"}
                                    SVGstrokeColor={"var(--YW_Theme_Active_Button_Background_Color)"}
                                    SVGstorkeWidth={"2"}
                                    emptyColor={darkmode ? "#1C1B2C" : "#FFFFFF"}
                                    iconsCount={5}
                                    allowFraction
                                    initialValue={rating}
                                    titleSeparator={titleSeparator}
                                />
                                 <div ref={announceRatingRef} aria-live="assertive" aria-atomic="true" className={styles.visuallyHidden}>
                                    Rating: {rating} out of 5 stars
                                </div>
                            </Stack>
                        </div>
                        <div className={styles.expText}>
                            <span tabIndex={0}>Please share any details about your experience.</span><br />
                            <Stack horizontal horizontalAlign="center" className={styles.feedbackInputContainer}>
                                <TextareaAutosize
                                    className={styles.feedbackInputTextArea}
                                    placeholder={placeholder}
                                    value={feedback}
                                    maxRows={5}
                                    name="txtQuestionInputText"
                                    aria-label="Feedback input"
                                    onChange={onFeedbackChange}
                                    onKeyDown={onEnterPress}
                                    maxLength={300}
                                />
                            </Stack>
                            <div tabIndex={0} aria-label={`Character count: ${textAreaCount} out of 300 characters used`} className={styles.feedbackCharCount}>
                              <span aria-hidden="true">{`${textAreaCount}/300`}</span>
                            </div>
                        </div>
                    </span>
                </Stack>
                )}
                {!showThankYouMessage && (
                    <Stack horizontal horizontalAlign="center" className={styles.submitButtonContainer}>
                        <CommandBarButton
                            role="button"
                            className={styles.closeButton}
                            onClick={closeFeedback}
                            text="CANCEL"
                            aria-label="CANCEL"
                            title="CANCEL"
                            onKeyDown={e => e.key === "Enter" || e.key === " " ? closeFeedback() : null}
                        />
                        <CommandBarButton
                            role="button"
                            className={sendFeedbackDisabled ? styles.submitButtonDisabled : styles.submitButton}
                            onClick={sendFeedback}
                            text="SUBMIT"
                            aria-label="Submit Feedback"
                            title="SUBMIT"
                            onKeyDown={e => e.key === "Enter" || e.key === " " ? sendFeedback() : null}
                        />
                    </Stack>
                )}
            </div>
        </Stack>
    );
};
